import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

export const WebsiteQuestion = () => {
    const intl = useIntl();
    const { register } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="website"
            label={
                <FormattedMessage
                    id="_.your_company.website"
                    defaultMessage="Website"
                />
            }
        >
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('website')}
                id="website"
                className="fs-exclude"
                placeholder={intl.formatMessage({
                    id: '_.your_company.website_placeholder',
                    defaultMessage: 'www.example.com'
                })}
            />
        </FieldRow>
    );
};
